import * as React from 'react';

export const LadderSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={53}
      height={159}
      viewBox='-0.5 -0.5 53 159'
      {...props}>
      <g fill='#994c00' pointerEvents='all'>
        <rect
          x={8}
          y={20}
          width={34}
          height={8.5}
          rx={1.7}
          ry={1.7}
          transform='rotate(-180 25 24.25)'
        />
        <rect
          x={-32.93}
          y={74.2}
          width={157.88}
          height={10}
          rx={2}
          ry={2}
          transform='rotate(-90 46.01 79.2)'
        />
        <rect
          x={8}
          y={47.5}
          width={34}
          height={8.5}
          rx={1.7}
          ry={1.7}
          transform='rotate(-180 25 51.75)'
        />
        <rect
          x={8}
          y={76}
          width={34}
          height={8.5}
          rx={1.7}
          ry={1.7}
          transform='rotate(-180 25 80.25)'
        />
        <rect
          x={8}
          y={106}
          width={34}
          height={8.5}
          rx={1.7}
          ry={1.7}
          transform='rotate(-180 25 110.25)'
        />
        <rect
          x={8}
          y={136}
          width={34}
          height={8.5}
          rx={1.7}
          ry={1.7}
          transform='rotate(-180 25 140.25)'
        />
        <rect
          x={-74}
          y={74.2}
          width={157.88}
          height={10}
          rx={2}
          ry={2}
          transform='rotate(-90 4.94 79.2)'
        />
      </g>
    </svg>
  );
};
